module.exports = __webpack_public_path__ + "img/206.8eb488d0.png";